import { FactoryProvider, InjectionToken } from '@angular/core';
import { Store } from 'redux';

import store from './store';

/** @deprecated use 'useStore', 'useDispatcher' and 'disuseStore' instead */
export const STORE = new InjectionToken<Store>('STORE');

/** @deprecated use 'useStore', 'useDispatcher' and 'disuseStore' instead */
export function StoreFactory(): Store {
    return store;
}

/** @deprecated use 'useStore', 'useDispatcher' and 'disuseStore' instead */
export const StoreProvider: FactoryProvider = {
    provide: STORE,
    useFactory: StoreFactory,
};
